/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Product/ProductAddToCart.Forms',[], function () {
    'use strict';

    var forms = {
        addInventoryNotificationForm: {
            Fields: [
                {
                    "Name": 'Email',
                    "Field": '#txtEmailMe',
                    "Param": 'email',
                    "Type": 'Text',
                    'Validators': [{
                        'Type': 'Email'
                    }]
                }
            ],
            Validate: true
        }
    };

    return forms;
});
